import { render, staticRenderFns } from "./NeiTuiManagement.vue?vue&type=template&id=05c255f2"
import script from "./NeiTuiManagement.vue?vue&type=script&lang=js"
export * from "./NeiTuiManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports